import { Extension } from "@tiptap/core";

export interface LineHeightOptions {
	types: string[];
	defaultLineHeight: string;
}

declare module "@tiptap/core" {
	interface Commands<ReturnType> {
		lineHeightCustom: {
			setLineHeight: (lineHeight: string) => ReturnType;
			unsetLineHeight: () => ReturnType;
		};
	}
}

const LineHeightCustom = Extension.create<LineHeightOptions>({
	name: "lineHeightCustom",

	addOptions() {
		return {
			types: ["paragraph", "heading"],
			defaultLineHeight: "1.6",
		};
	},

	addGlobalAttributes() {
		return [
			{
				types: this.options.types,
				attributes: {
					lineHeight: {
						default: this.options.defaultLineHeight,
						parseHTML: (element) =>
							element.style.lineHeight || this.options.defaultLineHeight,
						renderHTML: (attributes) => {
							if (!attributes.lineHeight) return {};
							return { style: `line-height: ${attributes.lineHeight}` };
						},
					},
				},
			},
		];
	},

	addCommands() {
		return {
			setLineHeight:
				(lineHeight: string) =>
					({ commands }) => {
						return this.options.types.every((type) =>
							commands.updateAttributes(type, { lineHeight })
						);
					},
			unsetLineHeight:
				() =>
					({ commands }) => {
						return this.options.types.every((type) =>
							commands.resetAttributes(type, "lineHeight")
						);
					},
		};
	},
});

export default LineHeightCustom;